export enum RoleEnum {
  apprentice = "apprentice",
  foreman = "foreman",
  journeyman = "journeyman",
}
